/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.781.2203c.0002.0002-.0002-.0002 0 0-.293-.2929-.7684-.2935-1.0613-.0006a.75.75 0 0 0 0 1.0606L13.4393 12 2.7197 22.7197a.75.75 0 0 0 1.0607 1.0606L15.5606 12 3.781.2203ZM20.5.75a.75.75 0 0 1 1.5 0v22.5a.75.75 0 0 1-1.5 0V.75Z"
    clipRule="evenodd"
  />,
  'PaginationEnd'
);
